import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import buildSubjectListPath from '@UI/Pages/Beneficiaries/Shared/Helpers/buildSubjectListPath';

/** Builds the dossier route. */
const buildSubjectPath = (subject: SubjectAddress): string => {
	return `${buildSubjectListPath(subject.typeKey)}/${subject.subjectId}`;
};

export default buildSubjectPath;
